export const isLinkForUnifiedWeb = async (link, locale) => {
  let pagesForNext = []
  try {
    pagesForNext = (await import(`../../public/locales/${locale}-slugs.json`))
      .slugs
  } catch (err) {
    console.error(`Could not load ${locale}-slugs.json:`, err)
    return false
  }

  let url = link
  if (link.startsWith('http')) {
    // We use indexOf to get the first match of `/` after the http:// or https://
    // in order to extract the slug of the url
    url = url.substring(url.indexOf('/', 8))
  }
  if (!url.startsWith('/')) url = `/${url}`
  return pagesForNext.some((element) => url.startsWith(element))
}
